import React, { useState } from 'react';
import { FiPlus } from 'react-icons/fi';
import AttachmentThumb from './attachment_thumb';
import VaultAttachmentViewer from './vault_attachment_viewer';

const Attachment = ({ note, onFileUpload, onFileRemove, pendingUploads }) => {
  const [dragOver, setDragOver] = useState(false);
  const [deleting, setDeleting] = useState(new Set());
  const [viewerIndex, setViewerIndex] = useState(null);

  const files = note.files || [];

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const file = e.dataTransfer.files[0];
    if (file) onFileUpload(note.vault_id, file);
  };

  const handleUploadClick = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.onchange = (e) => {
      const file = e.target.files[0];
      if (file) onFileUpload(note.vault_id, file);
    };
    input.click();
  };

  const handleDelete = (vault_id, file_id) => {
    setDeleting((prev) => new Set([...prev, file_id]));
    onFileRemove(vault_id, file_id);
  };

  const openViewer = (index) => {
    setViewerIndex(index);
  };

  return (
    <div
      className={`attachment-block${dragOver ? ' dragover' : ''}`}
      onDrop={handleDrop}
      onDragOver={(e) => {
        e.preventDefault();
        setDragOver(true);
      }}
      onDragLeave={() => setDragOver(false)}
    >
      <div className="attachment-block-header">
        <button
          type="button"
          className="attachment-add-btn"
          onClick={handleUploadClick}
          title="Add attachment"
        >
          <FiPlus />
        </button>
        <strong>Attachments</strong>
      </div>

      <div className="attachment-grid">
        {files.map((finfo, index) => {
          const isPending = pendingUploads?.has(finfo.file_name);
          const isDeleting = deleting.has(finfo.id);
          return (
            <div
              key={finfo.id}
              className={`attachment-tile${isPending || isDeleting ? ' pending' : ''}`}
              onClick={() => {
                if (isPending || isDeleting) return;
                openViewer(index);
              }}
            >
              {(isPending || isDeleting) && <div className="attachment-spinner" />}
              <AttachmentThumb finfo={{ ...finfo, pending: isPending || isDeleting }} />
              <div className="attachment-name" title={finfo.file_name || finfo.name}>
                {finfo.name || finfo.file_name}
              </div>
              {!isPending && !isDeleting && (
                <button
                  type="button"
                  className="attachment-delete"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDelete(finfo.vault_id, finfo.id);
                  }}
                >
                  ✖
                </button>
              )}
            </div>
          );
        })}
      </div>

      {viewerIndex != null ? (
        <VaultAttachmentViewer
          files={files}
          initialIndex={viewerIndex}
          onClose={() => setViewerIndex(null)}
        />
      ) : null}
    </div>
  );
};

export default Attachment;
